import { useState, useEffect, useCallback, useRef } from "react";

import { TaxRate } from "../bitmaker/schemas/Billing/TaxRate";

import { useApiError } from "./useApiError";

import { BitmakerAPIClient } from "../services/BitmakerApp";

const normalizeTaxRate = (taxRate: any): TaxRate => ({
  ...taxRate,
  rate: Number(taxRate.rate),
});

export const useTaxRates = () => {
  const [rates, setRates] = useState<TaxRate[]>([]);
  const [loadingTaxRates, setLoadingTaxRates] = useState(false);
  const [fetchTaxRatesError, setFetchTaxRatesError] = useState<string | null>(
    null,
  );

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchTaxRates = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingTaxRates(true);
    setFetchTaxRatesError(null);

    BitmakerAPIClient.get("/billing/settings/tax-rates", null, (response) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching tax rates:", message);
        setFetchTaxRatesError("Error fetching tax rates. Please try again.");
        setLoadingTaxRates(false);
        return;
      }

      const data = Array.isArray(response.data) ? response.data : [];
      setRates(data.map(normalizeTaxRate));
      setLoadingTaxRates(false);
    });
  }, [handleAPIError]);

  useEffect(() => {
    fetchTaxRates();
  }, [fetchTaxRates]);

  return {
    rates,
    loadingTaxRates,
    fetchTaxRatesError,
    refetchTaxRates: fetchTaxRates,
  };
};
